export default "/images/bank.png?1a5e810cea1feffa720f08718d6fe56a";